var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:['btn', 'white--text'],attrs:{"color":"green darken-2","disabled":_vm.isDisabled},on:{"click":_vm.handleClick}},[_c('v-icon',[_vm._v(" mdi-microsoft-excel ")]),_vm._v(" "+_vm._s(_vm.title)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }